import { defineComponent as _defineComponent } from 'vue'
import { UserType } from '@/models/userType';
import { hasCurrentUserPermission } from '@/utils/permissionUtils';
import * as modals from './modals';
import { values } from '@/utils/enum';
import { computed, getCurrentInstance } from 'vue';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'UserCreationDropdown',
  props: {
    allowedTypes: { default: () => values(UserType) as UserType[] },
    subsidiaryId: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { allowedTypes: UserType[], subsidiaryId?: number };





const { t } = useI18n();

const app = getCurrentInstance();

function isTypeEnabled(type: UserType): boolean {
  return props.allowedTypes!.includes(type);
}

function openGlobalAdminWizard() {
  modals.openGlobalAdminWizard(app, null, onWizardClosed);
}

async function openSubsidiaryAdminWizard() {
  await modals.openSubsidiaryAdminWizard(
    app,
    null,
    props.subsidiaryId,
    onWizardClosed,
  );
}

async function openCustomerWizard() {
  await modals.openCustomerUserWizard(app, null, onWizardClosed);
}

function openServiceGlobalWizard() {
  modals.openServiceGlobalUserWizard(app, null, onWizardClosed);
}

async function openServiceWizard() {
  await modals.openServiceUserWizard(
    app,
    null,
    props.subsidiaryId,
    onWizardClosed,
  );
}

function openTechnologyWizard() {
  modals.openTechnologyUserWizard(app, null, onWizardClosed);
}

function onWizardClosed() {
  emit('close');
}

const canCreateGlobalAdmin = computed(() =>
  hasCurrentUserPermission(UserType.GlobalAdmin),
);
const canCreateSubsidiaryAdmin = computed(() =>
  hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);
const canCreateCustomer = computed(() =>
  hasCurrentUserPermission(UserType.CustomerAdmin),
);
const canCreateEService = computed(() =>
  hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);
const canCreateTechnology = computed(() =>
  hasCurrentUserPermission(UserType.GlobalAdmin),
);

return { __sfc: true,props, emit, t, app, isTypeEnabled, openGlobalAdminWizard, openSubsidiaryAdminWizard, openCustomerWizard, openServiceGlobalWizard, openServiceWizard, openTechnologyWizard, onWizardClosed, canCreateGlobalAdmin, canCreateSubsidiaryAdmin, canCreateCustomer, canCreateEService, canCreateTechnology, UserType }
}

})